import { TranslationMap } from '@trimble-gcs/i18n-types';

export function scan3dIntensityTranslations() {
  return {
    intensityGradient: {
      text: $localize`:@@scan3dIntensity.intensityGradient:Intensity Gradient`,
      desc: 'Label for the intensity gradient slider.',
      limit: 30,
    },
  } satisfies TranslationMap;
}
